import { render, staticRenderFns } from "./FiatCard.vue?vue&type=template&id=6b9d8918&scoped=true"
import script from "./FiatCard.vue?vue&type=script&lang=js"
export * from "./FiatCard.vue?vue&type=script&lang=js"
import style0 from "./FiatCard.vue?vue&type=style&index=0&id=6b9d8918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d8918",
  null
  
)

export default component.exports